/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const StarIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='1em' height='1em' viewBox='0 0 16 16' {...props}>
			<path
				data-name='star'
				d='M3.581 16a.825.825 0 0 1-.5-.169.908.908 0 0 1-.331-.916l1.029-4.731L.291 6.989a.912.912 0 0 1-.249-.943.859.859 0 0 1 .731-.61l4.619-.438L7.218.539a.837.837 0 0 1 1.564 0l1.826 4.46 4.618.438a.858.858 0 0 1 .732.61.912.912 0 0 1-.249.943l-3.491 3.194 1.029 4.731a.907.907 0 0 1-.331.916.819.819 0 0 1-.935.042L8 13.389l-3.983 2.485a.826.826 0 0 1-.436.126ZM8 12.319a.826.826 0 0 1 .436.126l3.759 2.346-.971-4.466a.911.911 0 0 1 .269-.865l3.3-3.016-4.361-.413a.853.853 0 0 1-.707-.538L8 1.285 6.277 5.494a.851.851 0 0 1-.7.536l-4.361.413 3.3 3.016a.909.909 0 0 1 .269.865l-.971 4.466 3.759-2.345A.825.825 0 0 1 8 12.319ZM5.357 5.085Zm5.285 0Zm0 0'
				fill={color}
			/>
		</svg>
	)
}

export default StarIcon
